import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { DesignFormModel } from "src/app/design/design.model";
import { AuthService } from "src/app/auth.service";
import { Observable } from "rxjs";
import { singleSystem } from "../system/system";

@Injectable({
  providedIn: "root",
})
export class DesignService {
  private baseURL = environment.baseUrl;
  constructor(private http: HttpClient, private auth: AuthService) {}

  /**
   * Get Design List
   * @returns
   */
  getDesignList() {
    console.log(this.auth.getContractorInfo());
    console.log(this.baseURL);

    return this.http.get(
      `${this.baseURL}/rhAPI/designs/${
        this.auth.getContractorInfo().designer_id
      }/${this.auth.getContractorInfo().contractor_id}`
    );

  }

  /**
   * Get System By Design List
   * @returns
   */
  getSystemByDesign(designid: string | number) :Observable<any> {
    return this.http.get(`${this.baseURL}/rhAPI/getSystemByDesign/${designid}`);
  }

  removeSystem(selection_id: string | number): Observable<any> {
    return this.http.post(`${this.baseURL}/rhAPI/removeSystemFromDesign/${selection_id}`,{}, {observe: 'body'});
  }

  /**
   * Get System By Design List
   * @returns
   */
  getSystemByDesignComplete(designid: string | number) {
    return this.http.get(`${this.baseURL}/rhAPI/viewdesigns/${designid}`);
  }

  /**
   * Get Design by Id
   * @returns
   */
  getViewDesigns(designid: string | number) {
    return this.http.get(`${this.baseURL}/rhAPI/viewdesigns/${designid}`);
  }

  /**
   * Get One System Design
   * @returns
   */
  getSingleSystemDesign(selection_id: String | number) {
    return this.http.get(`${this.baseURL}/rhAPI/getRoom/${selection_id}`);
  }

  /**
   * Get One View System
   * @returns
   */
  getViewSystem(selection_id: String | number) {
    return this.http.get(`${this.baseURL}/rhAPI/view_system/${selection_id}`);
  }

  /**
   * Get One Design
   * @returns
   */
  getSingleDesign(designId: String | number) {
    return this.http.get(`${this.baseURL}/rhAPI/viewdesigns/${designId}`);
  }

  /**
   * Add New Design
   * @param Design
   * @returns
   */
  addNewDesign(design: DesignFormModel) {
    return this.http.post(`${this.baseURL}/rhAPI/designs`, design);
  }

  /**
   * Update Exisitng Design
   * @param Design
   * @returns
   */
  updateExisitngDesign(design: DesignFormModel) {
    return this.http.post(`${this.baseURL}/rhAPI/update_designs`, design);
  }

  /**
   * Delete Design
   * @param design_id
   * @returns
   */
  deleteDesign(design_id: String | number) {
    return this.http.post(
      `${this.baseURL}/rhAPI/delete_Design/${design_id}`,
      {}
    );
  }
}
